import { Vector3 } from '@babylonjs/core';
import { Button } from '@babylonjs/gui';
import { Game } from './Game';
import { GameState } from './GameState';
import { Gui, MenuNavigation } from './gui/Gui';

export class GameOver {
  private nav: MenuNavigation;

  constructor(public game: Game) {}

  async create() {
    await Gui.createDefaultScene(
      this.game,
      {
        url: 'assets/skybox/space.png',
        rotationAxis: 'y',
      },
      'Game Over'
    );
    await Gui.createAnimatedPlayer(this.game, 'WarriorIdle', new Vector3(0, -1, 0));
    await Gui.createBackButton(this.game, GameState.MAIN, '🎬');

    this.nav = new MenuNavigation(this.game);

    if (this.game.user.hasContinues()) {
      this.nav.addControl(await this.createContinueButton());
    }

    this.nav.addControl(await this.createRestartButton());
    this.nav.start();

    await this.game.sound.createBackgroundMusic('SaladeDeSaison');
  }

  useContinue() {
    this.game.sound.play('click');
    this.game.user.useContinue();
    this.game.user.save();
    this.game.routeTo(GameState.LEVEL);
  }

  restartGame() {
    this.game.sound.play('click');
    this.game.user.reset();
    this.game.user.save();
    this.game.routeTo(GameState.SELECTION);
  }

  async createContinueButton(): Promise<Button> {
    const button = this.game.gui2D.createButton(
      'button_continue',
      '🎮 Continue',
      () => {
        this.useContinue();
      },
      this.game.gui2D.ui.rootContainer,
      1,
      this.game.gui2D.sceneButtonColors()
    );
    this.game.gui2D.styleSceneButton(button);
    button.top = '25%';
    return button;
  }

  async createRestartButton(): Promise<Button> {
    const button = this.game.gui2D.createButton(
      'button_restart',
      '🖥️ Restart',
      () => {
        this.restartGame();
      },
      this.game.gui2D.ui.rootContainer,
      1,
      this.game.gui2D.sceneButtonColors()
    );
    this.game.gui2D.styleSceneButton(button);
    button.top = '35%';
    return button;
  }
}
